"use strict";

var _interopRequireDefault = require("/var/lib/jenkins/workspace/pay-center-front-master/node_modules/@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

require("core-js/modules/web.dom.iterable");

require("core-js/modules/es6.object.keys");

require("core-js/modules/es6.number.constructor");

var _BarChart = _interopRequireDefault(require("../components/BarChart"));

var _CardInfoV = _interopRequireDefault(require("@/views/dashboard/components/CardInfo/Merchant/CardInfoV1"));

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = {
  name: "merchant-v1",
  components: {
    BarChart: _BarChart.default,
    CardInfo: _CardInfoV.default
  },
  props: {
    data: Object,
    loading: Boolean,
    labels: Array,
    values: Array,
    httpAPI: Object,
    smppAPI: Object,
    redirectToDocs: Function,
    approvalStatus: Object,
    orgStatus: Object,
    numberOfDecimal: Number
  },
  computed: {
    cardInfo: function cardInfo() {
      if (Object.keys(this.data).length === 0) return;
      return [[{
        color: 'DarkSalmon',
        icon: 'fas fa-wallet',
        label: this.$t('dashboard.merchant.availableBalance'),
        value: parseFloat(this.data.processAvailableAmount),
        decimal: true,
        // unit: this.$store.getters.dollarSign
        numberOfDecimal: this.numberOfDecimal
      }, {
        color: 'Tan',
        icon: 'fas fa-file-invoice-dollar',
        label: this.$t('dashboard.merchant.frozenAmount'),
        value: parseFloat(this.data.processFrozenAmount),
        decimal: true,
        // unit: this.$t('dashboard.moneyUnit')
        numberOfDecimal: this.numberOfDecimal
      }], [{
        color: 'SkyBlue',
        icon: 'fas fa-envelope-open-text',
        label: this.$t('dashboard.merchant.uncreditedAmount'),
        value: parseFloat(this.data.processUncreditedAmount),
        decimal: false,
        // unit: this.$t('dashboard.merchant.smsUnit')
        numberOfDecimal: this.numberOfDecimal
      }, {
        color: 'MediumAquaMarine',
        icon: 'fas fa-donate',
        label: this.$t('dashboard.merchant.totalRecharge'),
        value: parseFloat(this.data.processAmount),
        decimal: true,
        // unit: this.$t('dashboard.moneyUnit')
        numberOfDecimal: this.numberOfDecimal
      }]];
    }
  }
};
exports.default = _default;